{
  "en": {
    "answers": [
      {
        "id": 1328440,
        "text": "The heart pumps blood through the body. (Correct)",
        "is_right": true
      },
      {
        "id": 1328441,
        "text": "The lungs produce insulin. (Incorrect)",
        "is_right": false
      },
      {
        "id": 1328442,
        "text": "The brain controls movements and sensory perception. (Correct)",
        "is_right": true
      },
      {
        "id": 1328443,
        "text": "Bones serve as the supporting framework of the body. (Correct)",
        "is_right": true
      },
      {
        "id": 1328444,
        "text": "The skin is not an organ. (Incorrect)",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 9934,
        "name": "Multiple Choice"
      },
      {
        "id": 156068,
        "name": "Sample Question"
      }
    ],
    "text": "Which of these statements about the human body are correct?",
    "display_in_order": true,
    "is_poll_question": false,
    "type": 0,
    "created_at": "2025-09-02T14:41:37.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:55:04.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "weblink": "https://quizacademy.de/tipps/#Tipps%20f%C3%BCr%20Quizfragen",
    "has_weblink": true,
    "explanation": "**Correct Answer(s):**\n\n* The heart pumps blood through the body. (Correct)\n* The brain controls movements and sensory perception. (Correct)\n* Bones serve as the supporting framework of the body. (Correct)\n\n**Further Information:**\n\n* The heart is the central pumping organ of the circulatory system.\n* The brain coordinates vital functions as well as movement and perception.\n* Bones form the supporting and protective system of the body.\n* The lungs do not produce insulin (this is done by the pancreas).\n* The skin is indeed an organ – in fact, the largest organ of the human body.\n\n**Notes:**\n\n* Multiple-choice questions may have several correct and several incorrect answers.\n* Ideally, provide four to five answer options.\n* Too many or overly long answers can make the question confusing.\n* Wrong answers should be close to the topic and not immediately obvious.\n* Formulate clearly, concisely, and use relevant keywords from your learning materials.\n\nMultiple-choice questions should be designed as an effective learning and testing tool. Keep correct and incorrect answers realistic but not unnecessarily complex. QuizAcademy places no limits on how long or detailed your questions may be.",
    "has_explanation": true,
    "num_answers": 5
  },
  "de": {
    "answers": [
      {
        "id": 1329025,
        "text": "Das Herz pumpt Blut durch den Körper. (Richtig)",
        "is_right": true
      },
      {
        "id": 1329026,
        "text": "Die Lunge produziert Insulin. (Falsch)",
        "is_right": false
      },
      {
        "id": 1329027,
        "text": "Das Gehirn steuert Bewegungen und Sinneswahrnehmungen. (Richtig)",
        "is_right": true
      },
      {
        "id": 1329028,
        "text": "Knochen dienen als Stützgerüst des Körpers. (Richtig)",
        "is_right": true
      },
      {
        "id": 1329029,
        "text": "Die Haut ist kein Organ. (Falsch)",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 9427,
        "name": "Musterfrage"
      },
      {
        "id": 9934,
        "name": "Multiple Choice"
      }
    ],
    "text": "Welche dieser Aussagen über den menschlichen Körper sind korrekt?",
    "display_in_order": true,
    "is_poll_question": false,
    "type": 0,
    "created_at": "2025-09-03T08:00:33.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:16:11.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "weblink": "https://quizacademy.de/tipps/#Tipps%20f%C3%BCr%20Quizfragen",
    "has_weblink": true,
    "explanation": "**Korrekte Antwort(en):**\n* Das Herz pumpt Blut durch den Körper. (Richtig)\n* Das Gehirn steuert Bewegungen und Sinneswahrnehmungen. (Richtig)\n* Knochen dienen als Stützgerüst des Körpers. (Richtig)\n\n**Weiterführende Informationen:**\n* Das Herz ist das zentrale Pumporgan des Blutkreislaufs.\n* Das Gehirn koordiniert lebenswichtige Funktionen sowie Bewegungen und Wahrnehmungen.\n* Knochen bilden das Stütz- und Schutzsystem des Körpers.\n* Die Lunge produziert kein Insulin (das übernimmt die Bauchspeicheldrüse).\n* Die Haut ist sehr wohl ein Organ – sogar das größte des Menschen.\n\n**Hinweise:**\n\n* Multiple-Choice-Fragen können mehrere richtige und mehrere falsche Antworten enthalten.\n* Optimal sind vier bis fünf Antwortmöglichkeiten.\n* Zu viele oder zu lange Antworttexte machen die Frage unübersichtlich.\n* Falsche Antworten sollten nah am Thema liegen und nicht sofort ins Auge fallen.\n* Formuliere prägnant, eindeutig und mit klaren Schlüsselbegriffen („Keywords“) aus Deinen Lerninhalten.\n\nBei **Multiple-Choice-Fragen** können generell mehrere Antworten richtig oder auch falsch sein, wobei hier **vier bis fünf Antwortmöglichkeiten** ideal sind.  Gestalte die richtigen und falschen Antwortmöglichkeiten nicht zu komplex und umfangreich – Quizfragen sollen eine effektive Lern- und Prüfungshilfe sein. Halte die falschen Antworten nah an dem Thema und lasse Sie, wenn möglich optisch nicht herausstechen. Solltest Du jedoch längere Texte und viele Antworten nutzen möchten, setzt Dir QuizAcademy keine Grenzen.",
    "has_explanation": true,
    "num_answers": 5
  }
}
